import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { urls } from "./config.dev";

function MissingDrugs({ token }) {
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchMissingDrugs = () => {
      fetch(urls.fetchmissingdrugs, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.missing_drugs && data.missing_drugs.length > 0) {
            displayMissingDrugsToast(data.missing_drugs);
            setError(false);
          }
        })
        .catch((err) => {
          console.error("Error fetching missing drugs:", err);
          setError(true);
          toast.error("Failed to load drug inventory status. Please refresh to try again.", {
            position: "bottom-right",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
    };

    fetchMissingDrugs();
  }, [token]);

  const displayMissingDrugsToast = (drugs) => {
    const toastMessage = (
      <div style={{
        maxHeight: "400px",
        overflowY: "auto",
        paddingRight: "8px",
        fontFamily: "'Segoe UI', Roboto, sans-serif"
      }}>
        <div style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "12px",
          borderBottom: "1px solid rgba(255,255,255,0.2)",
          paddingBottom: "8px"
        }}>
          <svg 
            style={{ marginRight: "10px", minWidth: "24px" }} 
            width="24" 
            height="24" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          >
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
            <line x1="12" y1="9" x2="12" y2="13"></line>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
          <strong style={{ fontSize: "16px" }}>
            Inventory Alert: Critical Drug Levels
          </strong>
        </div>
        
        <div style={{ 
          marginLeft: "34px",
          fontSize: "14px",
          lineHeight: "1.5"
        }}>
          {drugs.map((drug, index) => (
            <div 
              key={index} 
              style={{ 
                marginBottom: "10px",
                padding: "8px",
                backgroundColor: index % 2 === 0 ? "rgba(0,0,0,0.1)" : "transparent",
                borderRadius: "4px"
              }}
            >
              {drug.total_quantity === 0 ? (
                <>
                  <span style={{ color: "#ff6b6b", fontWeight: "600" }}>OUT OF STOCK:</span> {drug.drug_name} ({drug.packaging})
                </>
              ) : (
                <>
                  <span style={{ color: "#feca57", fontWeight: "600" }}>LOW STOCK:</span> Only {drug.total_quantity} remaining for {drug.drug_name} ({drug.packaging})
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    );

    toast.warning(toastMessage, {
      position: "bottom-right",
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  return (
    <ToastContainer
      position="bottom-right"
      autoClose={10000}
      newestOnTop
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      style={{
        width: "450px",
        maxWidth: "90vw"
      }}
      toastStyle={{
        backgroundColor: "#2c3e50",
        color: "#ecf0f1",
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
        padding: "16px",
        margin: "0 0 16px 0",
        borderLeft: "4px solid #e67e22"
      }}
      progressStyle={{
        background: "rgba(255,255,255,0.3)"
      }}
    />
  );
}

export default MissingDrugs;